module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Book.77d2c08d.woff2";